export default __webpack_public_path__ + "static/media/Ncash-large.610a58e3.png";